import { fetcher, http } from '@/app/utils/http'
import { KhatmRoute } from './khatm.route'
import { BaseApi } from '@/types'
import {
  CreateKhatmPayload,
  CreateKhatmResponse,
  Khatm,
  KhatmType,
} from './khatm.type'

export const getKhatmTypes = async () => {
  try {
    const res = (await (
      await fetcher(KhatmRoute.types, {
        next: { revalidate: 3600, tags: ['khatms-type'] },
      })
    ).json()) as BaseApi<KhatmType[]>
    return res.data
  } catch (error) {
    console.error('Error fetching khatm types:', error)
    return []
  }
}

export const getKhatmList = async ({
  pageParam = 1,
  search = '',
}: {
  pageParam?: number
  search?: string
} = {}) => {
  try {
    const res = (await (
      await fetch(KhatmRoute.list({ page: pageParam, search }), {
        cache: 'no-cache',
      })
    ).json()) as BaseApi<Khatm[]>

    return res
  } catch (error) {
    console.error('Error fetching khatm list:', error)
    return {
      statusCode: 500,
      message: 'error',
      data: [],
      meta: {
        total: 0,
        current_page: 1,
        last_page: 1,
        per_page: 0,
        has_more_pages: false,
      },
    }
  }
}

export const getKhatmDetials = async (id: string) => {
  try {
    const res = (await (
      await fetcher(KhatmRoute.khatmDetail(+id), {
        cache: 'default',
      })
    ).json()) as BaseApi<Khatm>

    return res.data
  } catch (error) {
    console.error('Error fetching khatm detail:', error)
    return null
  }
}

export const addTokhatm = async ({
  count,
  id,
}: {
  id: number
  count: string
}) => {
  return await http.post<BaseApi, { count: string }>(
    KhatmRoute.addToKhatm(+id),
    {
      count,
    }
  )
}

export const createKhatm = async (payload: CreateKhatmPayload) => {
  return await http.post<BaseApi<CreateKhatmResponse>, CreateKhatmPayload>(
    KhatmRoute.newKhatm,
    payload
  )
}
